import { Skeleton } from '../../../Skeleton'

import {
  REQUEST_PROFILE_TAB_INTERNAL_TASKS_SKELETON_CHECKLISTS_COUNT,
  REQUEST_PROFILE_TAB_INTERNAL_TASKS_SKELETON_ITEMS_COUNT,
} from './RequestProfileTabInternalTasksSkeleton.constants'

import * as styles from './RequestProfileTabInternalTasksSkeleton.module.css'

function RequestProfileTabInternalTasksSkeleton() {
  return (
    <div className={styles.RequestProfileTabInternalTasksSkeleton}>
      {Array.from({
        length: REQUEST_PROFILE_TAB_INTERNAL_TASKS_SKELETON_CHECKLISTS_COUNT,
      }).map((_, checklistIndex) => (
        <div className={styles.checklist} key={checklistIndex}>
          <Skeleton className={styles.header} />
          <div className={styles.items}>
            {Array.from({
              length: REQUEST_PROFILE_TAB_INTERNAL_TASKS_SKELETON_ITEMS_COUNT,
            }).map((__, itemIndex) => (
              <Skeleton className={styles.item} key={itemIndex} />
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export default RequestProfileTabInternalTasksSkeleton
